import React from 'react'
import Layout from '../../Layout/Layout'

export default function Dashboard({
    participantCounts,
    exchangeCounts,
    narcanCounts,
    dropinCounts,
    worksOutSum,
    holisticServicesCounts,
}) {
    return (
        <>
            <Layout title="Dashboard">
                <div className="flex flex-col gap-16 bg-white p-8 md:p-16 md:mb-0 mt-4">
                    <DisplayRow title="Intakes" today={participantCounts.todayTotal} yesterday={participantCounts.yesterdayTotal} month={participantCounts.monthTotal} ytd={participantCounts.ytdTotal} />
                    <DisplayRow title="Exchanges" today={exchangeCounts.todayTotal} yesterday={exchangeCounts.yesterdayTotal} month={exchangeCounts.monthTotal} ytd={exchangeCounts.ytdTotal} />
                    <DisplayRow title="Unique Drop In / Outreach Visits" today={dropinCounts.todayTotal} yesterday={dropinCounts.yesterdayTotal} month={dropinCounts.monthTotal} ytd={dropinCounts.ytdTotal} />
                    <DisplayRow title="Narcan / Naloxone" today={narcanCounts.todayTotal} yesterday={narcanCounts.yesterdayTotal} month={narcanCounts.monthTotal} ytd={narcanCounts.ytdTotal} />
                    <DisplayRow title="Works Out" today={worksOutSum.todayTotal} yesterday={worksOutSum.yesterdayTotal} month={worksOutSum.monthTotal} ytd={worksOutSum.ytdTotal} />
                    <DisplayRow title="Holistic Services" today={holisticServicesCounts.todayTotal} yesterday={holisticServicesCounts.yesterdayTotal} month={holisticServicesCounts.monthTotal} ytd={holisticServicesCounts.ytdTotal} />
                </div>
            </Layout>
        </>
    )
}


const DisplayRow = ({ title, today, yesterday, month, ytd }) => {
    return (
        <div className="flex flex-row flex-wrap w-auto gap-2">
            <h1 className="text-black text-4xl w-full font-semibold h-auto m-0">
                {title}
            </h1>
            <div className="flex flex-col m-2 shadow-md h-24 w-24 lg:h-36 lg:w-36">
                <div className="w-full bg-customYellow py-2">
                    <h3 className="text-gray-800 text-md lg:text-xl text-center">
                        Today
                    </h3>
                </div>
                <div className="h-full flex items-center">
                    <p className="w-full text-4xl lg:text-5xl text-black text-center py-2">
                        {today}
                    </p>
                </div>
            </div>
            <div className="flex flex-col m-2 shadow-md h-24 w-24 lg:h-36 lg:w-36">
                <div className="w-full bg-customYellow py-2">
                    <h3 className="text-gray-800 text-md lg:text-xl text-center">
                        Yesterday
                    </h3>
                </div>
                <div className="h-full flex items-center">
                    <p className="w-full text-4xl lg:text-5xl text-black text-center py-2">
                        {yesterday}
                    </p>
                </div>
            </div>
            <div className="flex flex-col m-2 shadow-md h-24 w-24 lg:h-36 lg:w-36">
                <div className="w-full bg-customYellow py-2">
                    <h3 className="text-gray-800 text-md lg:text-xl text-center">
                        This month
                    </h3>
                </div>
                <div className="h-full flex items-center">
                    <p className="w-full text-4xl lg:text-5xl text-black text-center py-2">
                        {month}
                    </p>
                </div>
            </div>
            <div className="flex flex-col m-2 shadow-md h-24 w-24 lg:h-36 lg:w-36">
                <div className="w-full bg-customYellow py-2">
                    <h3 className="text-gray-800 text-md lg:text-xl text-center">
                        YTD
                    </h3>
                </div>
                <div className="h-full flex items-center">
                    <p className="w-full text-4xl lg:text-5xl text-black text-center py-2">
                        {ytd}
                    </p>
                </div>
            </div>
        </div>
    )
}